import { LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { formatNumber } from '../../../utils/formatNumber';

const PerformanceChart = ({ data, type = 'earnings' }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-warm">
          <p className="text-sm font-medium text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center gap-2 text-xs">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: entry?.color }}
              />
              <span className="text-muted-foreground">{entry?.name}:</span>
              <span className="font-semibold text-foreground">
                {type === 'earnings' ? `${formatNumber(entry?.value)} ريال` : formatNumber(entry?.value)}
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  const formatYAxis = (value) => {
    if (type === 'earnings') {
      return value >= 1000 ? `${formatNumber(value / 1000)}k` : formatNumber(value);
    }
    return formatNumber(value);
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm">
      <div className="mb-4">
        <h3 className="text-lg md:text-xl font-bold text-foreground mb-1">
          {type === 'earnings' ? 'تحليل الأرباح' : 'تحليل الحجوزات'}
        </h3>
        <p className="text-sm text-muted-foreground">
          {type === 'earnings' ? 'الأرباح الشهرية خلال آخر 6 أشهر' : 'عدد الحجوزات الشهرية خلال آخر 6 أشهر'}
        </p>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        {type === 'earnings' ? (
          <AreaChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="earningsGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="var(--color-success)" stopOpacity={0.3} />
                <stop offset="95%" stopColor="var(--color-success)" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis
              dataKey="month"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
              tickFormatter={formatYAxis}
            />
            <Tooltip content={<CustomTooltip />} />
            <Area
              type="monotone"
              dataKey="earnings"
              name="الأرباح"
              stroke="var(--color-success)"
              strokeWidth={2}
              fill="url(#earningsGradient)"
            />
          </AreaChart>
        ) : (
          <LineChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis
              dataKey="month"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
              tickFormatter={formatYAxis}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend
              wrapperStyle={{ fontSize: '12px' }}
              iconType="circle"
            />
            <Line
              type="monotone"
              dataKey="completed"
              name="مكتملة"
              stroke="var(--color-success)"
              strokeWidth={2}
              dot={{ r: 4 }}
            />
            <Line
              type="monotone"
              dataKey="cancelled"
              name="ملغية"
              stroke="var(--color-error)"
              strokeWidth={2}
              dot={{ r: 4 }}
            />
          </LineChart>
        )}
      </ResponsiveContainer>
    </div>
  );
};

export default PerformanceChart;